import { AiOutlineCopyright } from "react-icons/ai";

export default function Footer() {
  return (
    <div className="footer">
      Manju
      <AiOutlineCopyright className="copyright" /> 2021
    </div>
  );
}
